import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["action", "className", "cols", "disabled", "error", "id", "label", "labelHidden", "maxLength", "message", "name", "onBlur", "onChange", "onFocus", "optionalLabel", "placeholder", "readOnly", "rows", "value", "wrap", "required"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Label from '../Label';
import Message from '../Message';
import Box from '../Box';
import styles from './index.module.scss';
var Textarea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var action = _ref.action,
      className = _ref.className,
      cols = _ref.cols,
      disabled = _ref.disabled,
      error = _ref.error,
      id = _ref.id,
      label = _ref.label,
      labelHidden = _ref.labelHidden,
      maxLength = _ref.maxLength,
      message = _ref.message,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      optionalLabel = _ref.optionalLabel,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      rows = _ref.rows,
      value = _ref.value,
      wrap = _ref.wrap,
      required = _ref.required,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var labelId = id + "-label";
  var messageId = id + "-message";
  var isRequired = required !== undefined ? required : !optionalLabel;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 3,
    clone: true
  }, /*#__PURE__*/React.createElement(Label, {
    action: action,
    hidden: labelHidden,
    htmlFor: id,
    id: labelId,
    optional: optionalLabel
  }, label)), /*#__PURE__*/React.createElement("textarea", _extends({
    "aria-describedby": message && messageId,
    "aria-invalid": !!error,
    "aria-labelledby": labelId,
    "aria-required": isRequired ? 'true' : 'false',
    className: cx(styles.textarea, error && styles.error),
    cols: cols,
    disabled: disabled,
    id: id,
    maxLength: maxLength,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    readOnly: readOnly,
    ref: ref,
    required: isRequired,
    rows: rows,
    value: value,
    wrap: wrap
  }, rest)), message && /*#__PURE__*/React.createElement(Box, {
    pt: 2,
    clone: true
  }, /*#__PURE__*/React.createElement(Message, {
    error: error,
    id: messageId
  }, message)));
});
Textarea.displayName = 'Textarea';
Textarea.identifier = Textarea.displayName; // used in docs website

Textarea.clonableProps = ['flexProps', 'positioningProps', 'marginProps', 'paddingProps', 'widthProps', 'floatProps'];
Textarea.defaultProps = {};
export default Textarea;